<div class="prescription-size" mat-dialog-content>
  @if (this.isInBulk) {
    <div class="count-progress">
      <p>Progresso de Liberação de solução medicamentosa</p>
      <mat-progress-bar mode="determinate" [value]="this.progressDispensation"></mat-progress-bar>
      <div>
        <span>{{indexSolution+1}}/{{this.listSolution.length}} selecionado(s)</span>
      </div>
    </div>
  }
  <div class="mat-dialog-content">
    <div class="head-exam-modal-list">
      <span class="bold-name">Paciente: </span>
      <span> {{data.episode.patientSocialName? data.episode.patientSocialName :
        data.episode.patientName}}
      </span>
    </div>

    <div class="body-exam-modal-list">
      <form class="form" [formGroup]="model" (ngSubmit)="submit()">
        <div class="row">
          @for (prescription of this.solution.listSolutionMedicine; track prescription) {
            <div class="col-12 column-name-title"
              >
              <div class="col-3 column-name"> <span class="bold-name">Nome do medicamento:</span>
              <span>{{prescription.medicineName}}</span>
              <div class="tag-container">
                @for (tag of prescription?.listTags; track tag) {
                                    <span class="tag-header-prescription" [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 
                        'color': 'white' } : {}">{{tag.tagName}}</span>
                }
              </div>
            </div>
            <div class="col-2 column-name">
              <span class="bold-name">Quantidade:</span>
              <span>{{prescription.prescriptionSolutionMedicine.quantity}}</span>
            </div>
            <div class="col-2 column-name">
              <span class="bold-name">Unidade:</span>
              <span>{{prescription.measurementUnitName}}</span>
            </div>
            <div class="col-3 column-name">
              <div class="d-flex flex-column">
                <div>
                  <span class="bold-name">Dose a ser administrada: </span>
                  <span>{{prescription.doseToAdministeredName}}</span>
                </div>
                <div style="margin-top: 4px;">
                  <span class="bold-name">Total em 24h:</span>
                  <span>
                    {{prescription.prescriptionSolutionMedicine.calculatedTotalQuantity ?
                    prescription.prescriptionSolutionMedicine.calculatedTotalQuantity : '-'}}
                    {{prescription.doseToAdministeredName}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-2 column-button">
              @if (prescription.prescriptionSolutionMedicine.idPrescriptionStatus == statusOpenPrescriptionEnum || prescription.prescriptionSolutionMedicine.idPrescriptionStatus == null || prescription.prescriptionSolutionMedicine.idPrescriptionStatus == undefined) {
                <div
                  >
                  <button class="custom-button" mat-flat-button color="primary" type="button"
                  (click)="openPrescriptionSolutionModal(prescription)">Liberar</button>
                </div>
              }
              @if (prescription.prescriptionSolutionMedicine.idPrescriptionStatus != statusOpenPrescriptionEnum) {
                <div
                  >
                  <button class="custom-button" mat-flat-button color="primary" type="button"
                  (click)="openPrescriptionSolutionModal(prescription)">Editar</button>
                </div>
              }
              @if (prescription.prescriptionSolutionMedicine.idPrescriptionStatus == statusLiberatePrescriptionEnum) {
                <div
                  >
                  <span class="type-dispensing">Dispensado</span>
                </div>
              }
              @if (prescription.prescriptionSolutionMedicine.idPrescriptionStatus == statusNotDispensationPrescriptionEnum) {
                <div
                  >
                  <span class="type-non-dispensing">Não dispensado</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class="col-12 column-name-title">
          <div class="col-4 column-name">
            <span class="bold-name">Apresentação:</span>
            <span>{{this.solution.presentationName}}</span>
          </div>
          <div class="col-3 column-name">
            <span class="bold-name">Uso:</span>
            <span>{{this.solution.usage}}</span>
          </div>
          <div class="col-3 column-name">
            <span class="bold-name">Forma de consumo:</span>
            <span>{{this.solution.administrationTypeName}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 column-name-title">
          <div class="col-4 column-name">
            <span class="bold-name">Frequência:</span>
            <span>{{this.solution.frequencyName}}</span>
          </div>
          <div class="col-3 column-name">
            <span class="bold-name">Período de tratamento:</span>
            <span>{{this.solution.treatmentPeriodName}}</span>
          </div>
          <div class="col-3 column-name">
            <span class="bold-name">Diluição:</span>
            <span>{{this.solution.dilutionName}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 column-name-title">
          <div class="col-4 column-name">
            <span class="bold-name">Observação:</span>
            <span>{{this.solution.prescriptionSolution.observation}}</span>
          </div>
          <div class="col-3 column-name">
            <span class="bold-name">Unidade de diluição:</span>
            <span>{{this.solution.dilutionUnitName}}</span>
          </div>
          <div class="col-3 column-name">
            <span class="bold-name">Quantidade de diluição:</span>
            <span>{{this.solution.prescriptionSolution.dilutionQuantity}}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Local</mat-label>
            <mat-select formControlName="idLocation">
              @for (item of listLocation; track item) {
                <mat-option [value]="item.idLocation">
                {{item.locationName}}</mat-option>
              }
            </mat-select>
            @if (model.get('idLocation').invalid) {
              <mat-error>Informe o local</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div>
        <div class="additional-itens-header">
          <h2>Materiais e quantidades adicionais</h2>
          <div class="col-12 col-md-4">
            <button mat-flat-button color="primary" type="button" class="btn-block"
              (click)="openAdditionalItemsModal()">
              @if (isLoading == false) {
                <span>Adicionar/editar</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"
                ></mat-spinner>
              }
            </button>
          </div>
        </div>
        <div>
          @if ((!listAdditionalItemsForRequest || listAdditionalItemsForRequest.length == 0) && (!listAdditionalMedicinesForRequest || listAdditionalMedicinesForRequest.length == 0)) {
            <app-empty-list
            [message]="'Não há materiais adicionais'"></app-empty-list>
          }
          @if ((listAdditionalItemsForRequest && listAdditionalItemsForRequest.length > 0 ) || (listAdditionalMedicinesForRequest && listAdditionalMedicinesForRequest.length > 0)) {
            <app-table-additional-items-prescription-release
              [listAdditionalItems]="listAdditionalItemsForRequest"
              [listAdditionalMedicines]="listAdditionalMedicinesForRequest">
            </app-table-additional-items-prescription-release>
          }
        </div>
      </div>
    </form>
  </div>
</div>
</div>
<div mat-dialog-footer class="footer-modal">
  <div class="footer-exam-modal-list row">
    <div class="col-8 col-md-4 col-sm-3">
      <button mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">
        @if (isLoading == false) {
          <span>Fechar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    <div class="col-8 col-md-4 col-sm-3">
      <button class="button-non-dispense" mat-flat-button color="primary" class="btn-block"
        (click)="nonDispensationAllModalComponent(this.solution)" [disabled]="nonDispenseAll">
        @if (isLoading == false) {
          <span style="font-size: 13.7px;">Não dispensar todos</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    <div class="col-8 col-md-4 col-sm-3">
      <button mat-flat-button color="primary" class="btn-block" (click)="submit()" [disabled]="!validated">
        @if (isLoading == false) {
          <span>Liberar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>